import { gql } from "@apollo/client";

export const TRAILHEAD_RANKS_QUERY = gql`
  fragment TrailheadRank on TrailheadRank {
    __typename
    title
    requiredPointsSum
    requiredBadgesCount
    imageUrl
  }

  fragment PublicProfile on PublicProfile {
    __typename
    trailheadStats {
      __typename
      earnedPointsSum
      earnedBadgesCount
      completedTrailCount
      rank {
        ...TrailheadRank
      }
      nextRank {
        ...TrailheadRank
      }
    }
  }

  query GetTrailheadRank($trailblazerId: String, $queryProfile: Boolean!) {
    # Local State query for TBID
    profileUser @client {
      isSelf @client
      id @client @export(as: "trailblazerId")
    }

    profile(trailblazerId: $trailblazerId) @include(if: $queryProfile) {
      ... on PublicProfile {
        ...PublicProfile
      }
      ... on PrivateProfile {
        __typename
      }
    }

    siteInfo @client {
      urls {
        trailhead
        trailheadRanks
      }
    }
  }
`;
